/** Dependencies */
import React from 'react';
import { useTranslation } from 'react-i18next';

/** Styles */
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';

/** Components */
import EmptyState from '../../../components/EmptyState';

/** Hooks */
import useBranches from '../../../hooks/useBranches';
import useProfile from '../../../hooks/useProfile';
import keyHasPermission from '../../../helpers/keyHasPermission';

function SectionSalesTable() {
  const { t } = useTranslation('sectionSales');
  const { meProfile } = useProfile();

  const { salesBySections } = useBranches();

  const hasViewPermission = keyHasPermission(
    'view-daily-report',
    meProfile?.permissions || [],
  );
  const renderEmpty = () => (
    <EmptyState
      message={
        !hasViewPermission
          ? 'Bu sayfayı görmeye yetkiniz yok!'
          : t('reports.empty')
      }
    />
  );

  return (
    <Paper sx={{ width: '100%', p: 2 }}>
      {!hasViewPermission || !salesBySections ? (
        renderEmpty()
      ) : (
        <TableContainer>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell align="center">
                  {t('reports.reportsTable.section')}
                </TableCell>
                <TableCell align="center">
                  {t('reports.reportsTable.guest_count')}
                </TableCell>
                <TableCell align="center">
                  {t('reports.reportsTable.discount')} (
                  {meProfile?.currency?.symbol})
                </TableCell>
                <TableCell align="center">
                  {t('reports.reportsTable.amount')} (
                  {meProfile?.currency?.symbol})
                </TableCell>
                <TableCell align="center">
                  {t('reports.reportsTable.rate')} (%)
                </TableCell>
              </TableRow>
            </TableHead>
            {salesBySections?.sections.map(row => (
              <TableBody>
                <TableRow key={row.section.id}>
                  <TableCell align="center">{row.section.name}</TableCell>
                  <TableCell align="center">{row.total_guest_count}</TableCell>
                  <TableCell align="center">
                    {row.total_discount.formatted}
                  </TableCell>
                  <TableCell align="center">
                    {row.total_sales_amount.formatted}
                  </TableCell>
                  <TableCell align="center">{row.rate}</TableCell>
                </TableRow>
              </TableBody>
            ))}
            <TableBody>
              <TableRow style={{ background: '#f0f0f0' }}>
                <TableCell style={{ fontWeight: '700' }} align="center">
                  {t('reports.reportsTable.total')}
                </TableCell>
                <TableCell style={{ fontWeight: '700' }} align="center">
                  {salesBySections.total_guests}
                </TableCell>
                <TableCell style={{ fontWeight: '700' }} align="center">
                  {salesBySections?.total_discount.formatted}
                </TableCell>
                <TableCell style={{ fontWeight: '700' }} align="center">
                  {salesBySections?.total_amount.formatted}
                </TableCell>
                <TableCell align="center">{salesBySections?.rate}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Paper>
  );
}

export default SectionSalesTable;
